<template>
	<div class="edit-story layout-column layout-hv-center" id="edit-story">
		<layout-gray>
			<el-collapse v-model="activeNames">
				<el-collapse-item :title="(!is18)?'* 1. 成立小組（由輔導員填寫）': '* 1. 成立小組（由代表人及綁定帳號者填寫）'" name="1" id="el1">
					<team :editStoryData="editStoryData" v-if="!isEdit[0]" @edit="changeEditType(0)" @next="handleNext('1')" :is18="is18" />
					<TeamFormUnder18 :editStoryData="editStoryData" v-if="isEdit[0] && !is18" @browsMode="changeEditType(0)"></TeamFormUnder18>
					<TeamFormUpper18 :editStoryData="editStoryData" v-if="isEdit[0] && is18" @browsMode="changeEditType(0)"></TeamFormUpper18>
				</el-collapse-item>
				<el-collapse-item title="* 2.1 感受" name="2" id="el2">
					<Problem :editStoryData="editStoryData" v-if="!isEdit[1]" @edit="changeEditType(1)" @next="handleNext('2')" />
					<ProblemForm :editStoryData="editStoryData" v-else @browsMode="changeEditType(1)" />
				</el-collapse-item>
				<el-collapse-item title="* 2.2 以照片分享歷程：上傳 DFC 四步驟照片" name="3" id="el3">
					<pictures v-if="!isEdit[2]" @edit="changeEditType(2)" @next="handleNext('3')" />
					<pictures-form v-else @browsMode="changeEditType(2)" />
				</el-collapse-item>
				<el-collapse-item title="* 2.3 以文字分享歷程：上傳 DFC 四步驟學習單" name="4" id="el4">
					<Pdf v-if="!isEdit[3]" @edit="changeEditType(3)" @next="handleNext('4')"></Pdf>
					<PdfForm v-else @browsMode="changeEditType(3)"></PdfForm>
				</el-collapse-item>
				<el-collapse-item title="2.4 DFC 挑戰故事授權同意書" name="5" id="el5">
					<Auth v-if="!isEdit[4]" :is18="is18" @edit="changeEditType(4)" @next="handleNext('5')"></Auth>
					<AuthForm v-else :is18="is18" @browsMode="changeEditType(4)"></AuthForm>
				</el-collapse-item>
				<el-collapse-item title="2.5 上傳 DFC 挑戰故事影片" name="6" id="el6">
					<Video v-if="!isEdit[5]" @edit="changeEditType(5)" @next="handleNext('6')"></Video>
					<VideoForm v-else @browsMode="changeEditType(5)"></VideoForm>
				</el-collapse-item>
				<el-collapse-item title="2.6 SDGs" name="7" id="el7">
					<Sdgs v-if="!isEdit[6]" @edit="changeEditType(6)" @next="handleNext('7')"></Sdgs>
					<SdgsForm v-else @browsMode="changeEditType(6)"></SdgsForm>
				</el-collapse-item>
				<el-collapse-item title="* 3.1 填寫國際證書資料" name="8" id="el8">
					<Certificate v-if="!isEdit[7]" @edit="changeEditType(7)" :is18="is18" @next="handleNext('8')"></Certificate>
					<CertificateForm v-else :is18="is18" @browsMode="changeEditType(7)"></CertificateForm>
				</el-collapse-item>
				<el-collapse-item v-if="userInfo.role != 'visitor'" title="* 3.2 填寫輔導員問卷" name="9" @next="handleNext('9')" id="el9">
					<Questionnaire :is18="is18"></Questionnaire>
				</el-collapse-item>
			</el-collapse>
			<div v-if="userInfo.role != 'visitor'" class="submit col">
				<div class="el-collapse-item__header">3.3 報名參加分享舞臺</div>
				<div class="el-collapse-item__content col" gutter="25">
					<p>我想讓我的故事被更多人看見：</p>
					<div class="col" align-x="center" gutter="40">
						<div class="col" gutter="5" style="width:80%">
							<el-popover trigger="hover" title="提示" placement="top">
								<i class="el-icon-info" style="color:red;">&nbsp;如欲參加分享舞台，請確認：
									<ol>
										<li><b>步驟 2.5「故事影片」</b>已上傳；</li>
										<li><b>步驟2.4「同意授權」</b>勾選<b>同意</b></li>
									</ol>
								</i>
								<el-tag class="center" slot="reference">
									<el-checkbox v-model="editStoryData.is_participate" :disabled="checkboxDisabled">我希望讓更多人看見我們的故事</el-checkbox>
								</el-tag>
							</el-popover>
							<br>
							<span>*請務必完成填寫步驟 2.4 故事資料授權喔！
								<br>*勾選此選項，僅代表貴團隊有意願被主辦單位和共同主辦單位媒合，每年媒合的管道與數量不同，如有合適的機會，我們將主動聯繫您。
								<br>*主辦單位和共同主辦單位保有隨時修改及終止本活動之權利，若有更動，將依 照活動官網網站公佈為準。</span>
						</div>
						<div class="col layout-align-center" gutter="5">
							<div class="button-tp submit-story-button color-white bg-pink1" :class="{'disableApply': disableApply}" @click="handleApplyStory(editStoryData)">送出故事資料</div>
							<span class="color-danger">送出後資料將無法再作修改！</span>
						</div>
					</div>
				</div>
			</div>
		</layout-gray>
		<div class="footer-btn-box layout-row">
			<el-button type="info" class="back-btn" @click="backPost">
				回上一頁</el-button>
			<el-button class="failed-mesage-btn" type="primary" :disabled="editStoryData.apply_status != 3" @click="applyFailedDialogVisible = true" v-if="editStoryData.apply_status == 3">
				顯示資料不完整提示</el-button>
		</div>

		<el-dialog title="資料不完整" :visible.sync="applyFailedDialogVisible">
			<p>感謝你與我們分享你改變世界的故事，離上傳完成就差一點點了！<br>以下資料需要再次確認喔！</p>
			<div v-html="failMessageTransform"></div>
			<p>你可以在資料確認完整後，再次送出，<br />與我們分享你的故事！</p>
			<p>DFC 挑戰客服信箱 challenge@dfctaiwan.org
				<br />DFC 挑戰客服專線 (02) 2368-1310
				<br />服務時間：週一至週五，上午10:00~18:00
			</p>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="applyFailedDialogVisible = false">確定</el-button>
			</div>
		</el-dialog>
	</div>

</template>

<script>
import LayoutGray from "@/components/challenge/signUp/LayoutGray.vue";
import { mapActions, mapState } from "vuex";
import config from "@/data/config.json";
import Joi from "joi";
import _ from "lodash";

import {
	Team,
	TeamFormUnder18,
	TeamFormUpper18,
	Problem,
	ProblemForm,
	Video,
	VideoForm,
	Auth,
	AuthForm,
	Certificate,
	CertificateForm,
	PicturesForm,
	Pictures,
	Pdf,
	PdfForm,
	Questionnaire
} from "@/components/challenge/signUp/editStory";

export default {
	components: {
		LayoutGray,
		Team,
		TeamFormUnder18,
		TeamFormUpper18,
		Problem,
		ProblemForm,
		Video,
		VideoForm,
		Auth,
		AuthForm,
		Certificate,
		CertificateForm,
		PicturesForm,
		Pictures,
		Pdf,
		PdfForm,
		Questionnaire,
		Sdgs: () => import("@/components/challenge/signUp/editStory/SDGs"),
		SdgsForm: () => import("@/components/challenge/signUp/editStory/SDGsForm")
	},
	data() {
		return {
			applyFailedDialogVisible: false,
			isEdit: [false, false, false, false, false, false, false, false],
			activeNames: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
			is18: false,
			shareSession: config.shareSession,
			blackList: [0, 1, 2, 3, 4, 8, 9],	// 必填項目
		};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		...mapState("user", ["userInfo"]),
		failMessageTransform() {
			var message = this.editStoryData.failed_message;
			if (this.editStoryData.failed_message) {
				return message.replace(/[\r\n]/g, "<br/>");
			}
		},
		checkboxDisabled() {
			let authVal = this.handleAuth();
			const { src } = this.editStoryData && this.editStoryData.video || new Object;
			const { agree_authorize } = this.editStoryData || new Object;

			if (authVal && src && agree_authorize) return false;
			else {
				this.editStoryData.is_participate = false;
				return true;
			}
		},
		disableApply() {
			let storyStatus = this.editStoryData.apply_status;
			let canEditStatus = [1, 3];

			if (this.userInfo.role == "visitor") {
				return true;
			}

			if (
				_.indexOf(canEditStatus, storyStatus) != -1 &&
				this.userInfo.role != "visitor"
			) {
				return false;
			}

			return true;
		}
	},
	methods: {
		...mapActions("story", [
			"fetchEditStory",
			"applyStory",
			"getQuestionnaireStatus"
		]),

		changeEditType(i) {
			this.$set(this.isEdit, i, !this.isEdit[i]);
		},
		async init() {
			this.storyId = this.$route.params.id;
			if (this.$route.query.is18) {
				this.is18 =
					this.$route.query.is18 &&
					JSON.parse(this.$route.query.is18);
			}
			await this.getStoryData();
			this.initIsEdit();
			this.detetctIsFailed();
		},
		initIsEdit() {
			let barList = _.cloneDeep(this.editStoryData.progress.bar_list);
			this.isEdit.map((item, index) => {
				// 因為組員資料佔2個進度所以要+1
				if (!barList[index + 1]) {
					this.isEdit[index] = true;
				}
			});
			this.isEdit = _.cloneDeep(this.isEdit);
		},
		detetctIsFailed() {
			if (this.editStoryData.apply_status == 3) {
				this.applyFailedDialogVisible = true;
			}
		},
		async getStoryData() {
			try {
				await this.fetchEditStory(this.storyId);
				await this.getQuestionnaireStatus();
				if (this.$route.query.is18 == undefined) {
					this.$router.replace({
						query: { is18: this.editStoryData.is_18 }
					});
					this.is18 = this.editStoryData.is_18;
				}
			} catch (e) {
				this.$message.error(e);
			}
		},
		handleNext(name) {
			if (_.indexOf(this.activeNames, name) != -1) {
				_.remove(this.activeNames, activeName => {
					return activeName == name;
				});
			} else {
				this.activeNames.push(name);
			}
			this.activeNames = _.cloneDeep(this.activeNames);
		},
		backPost() {
			window.history.go(-1);
		},
		checkValidate(progress) {
			/**
			 * 0: 填寫小組成員資訊
			 * 1: 加入其他輔導員夥伴
			 * 2: 感受
			 * 3: 照片
			 * 4: 學習單
			 * 5: 創用CC授權書
			 * 6: 影片
			 * 7: SDGs
			 * 8: 國際證書
			 * 9: 輔導員問卷
			 * 10: DFC Taiwan 審核
			 */
			let list = progress.bar_list;
			// 黑名單裡必須找不到false項目（未完成項目）
			return this.blackList.every(i => list[i]);
		},
		async handleApplyStory(data) {
			if (!this.disableApply) {
				this.$confirm("送出後資料將無法再作修改！", "提示", {
					confirmButtonText: "確定",
					cancelButtonText: "取消",
					type: "warning"
				})
					.then(async () => {
						if (!this.disableApply) {
							if (this.checkValidate(data.progress)) {
								await this.applyStory(data);
								this.$message.success(
									"報名成功，我們會儘速審核"
								);
								this.isEdit.map((item, index) => {
									this.isEdit[index] = false;
								});
								this.isEdit = _.cloneDeep(this.isEdit);
							} else {
								this.scrollToError(data.progress);
								this.$message.error(data.progress.message);
							}
						}
					})
					.catch(() => { });
			}
		},
		async scrollToError({ bar_list }) {
			const index = this.blackList.find(i => !bar_list[i]);
			this.$scrollTo(`#el${index}`, 700, {});
		},
		validator(data, schema) {
			const { error } = Joi.validate(data, schema, {
				allowUnknown: true
			});
			if (error) return false;
			return true;
		},
		handleAuth() {
			let data = this.editStoryData;
			let authTeamMambersVal;
			authTeamMambersVal = this.validator(
				data.team_members,
				Joi.array()
					.min(1)
					.required()
			);

			let authCounselorsVal = this.validator(
				data.counselors,
				Joi.array()
					.min(1)
					.required()
			);

			if (authTeamMambersVal && authCounselorsVal) {
				return true;
			} else {
				return false;
			}
		}
	},
	async created() {
		await this.init();
		this.$notify({
			title: "警告",
			message: "系統只支援單人存取，請避免多人同時編輯同一欄位。",
			type: "warning",
			duration: 0
		});
	}
};
</script>

<style lang="scss">
.edit-story {
	max-width: 900px;

	.disableApply {
		background-color: #909399;
		cursor: not-allowed;
	}

	.el-collapse-item__header {
		background-color: #ececec !important;
		padding-left: 10px;
	}
	.el-collapse-item__content {
		background-color: #f6f7f8 !important;
		padding: 20px;
	}
	.el-collapse-item__arrow {
		line-height: 48px !important;
	}

	.submit-story-button {
		width: 380px;
		height: 52px;
	}

	.footer-btn-box {
		margin: 20px 40px;
	}
}
</style>
